/**
 * "+ Projekt zuordnen" - eine Verknuepfung von der Seite des Elternteils aus
 * herstellen (Roadmap F-11: Zuordnung von beiden Seiten).
 *
 * Ein Auswahlfeld, das nach der Wahl sofort zuordnet und sich zuruecksetzt.
 * Ohne Kandidaten erscheint es gar nicht - ein leeres Feld waere nur Rauschen.
 */
import { cn } from '@/lib/utils/cn';
import type { ID } from '@/domain/types';

export interface AssignOption {
  id: ID;
  label: string;
}

export function AssignSelect({
  label, options, onAssign, className,
}: {
  /** z. B. "Projekt zuordnen". */
  label: string;
  options: AssignOption[];
  onAssign: (id: ID) => void;
  className?: string;
}) {
  if (options.length === 0) return null;

  return (
    <select
      value=""
      onChange={(e) => { if (e.target.value) onAssign(e.target.value); }}
      aria-label={label}
      className={cn(
        'h-7 max-w-full rounded-md border border-dashed border-line bg-transparent px-1.5',
        'text-[12px] text-ink-muted transition-colors hover:border-line-strong',
        'focus:border-accent focus:outline-none',
        className,
      )}
    >
      <option value="">+ {label}</option>
      {options.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
    </select>
  );
}
